const request = require('superagent');

const LineItemAPI = {
    add: (params) => {
        const sanitizedQueryParams = {};
        sanitizedQueryParams.locale = params.locale;

        return request
            // eslint-disable-next-line max-len
            .post(`${process.env.REACT_APP_MAIN_STORE_API_HOST}/api/v2/storefront/cart/add_item?include=line_items,line_items.variant.images,variants.product.images,line_items.data_extras,variants.product.data_extra_types`)
            .set('X-Spree-Order-Token', params.orderToken)
            .set('Content-Type', 'application/vnd.api+json')
            .query(sanitizedQueryParams)
            .send({
                variant_id: params.variantId,
                quantity: params.quantity,
                zone_id: params.zoneId,
                ...(params.extraParam && { data_extras: params.extraParam }),
            })
            .then((response) => response);
    },

    destroy: (params) => {
        const sanitizedQueryParams = {};
        sanitizedQueryParams.locale = params.locale;

        return request
            .delete(`${process.env.REACT_APP_MAIN_STORE_API_HOST}/api/v2/storefront/cart/remove_line_item/${params.lineItemId}`)
            .set('X-Spree-Order-Token', params.token)
            .set('Content-Type', 'application/vnd.api+json')
            .query(sanitizedQueryParams);
    },

    destroyDataExtra: (params) => {
        const sanitizedQueryParams = {};
        sanitizedQueryParams.locale = params.locale;

        return request
            // eslint-disable-next-line max-len
            .delete(`${process.env.REACT_APP_MAIN_STORE_API_HOST}/api/v2/storefront/cart/remove_data_extra/${params.dataExtraId}?include=line_items,line_items.variant.images,variants.product.images,line_items.data_extras,variants.product.data_extra_types`)
            .set('X-Spree-Order-Token', params.token)
            .set('Content-Type', 'application/vnd.api+json')
            .query(sanitizedQueryParams);
    },

    update: (params) => {
        const sanitizedQueryParams = {};
        sanitizedQueryParams.locale = params.locale;

        return request
            // eslint-disable-next-line max-len
            .patch(`${process.env.REACT_APP_MAIN_STORE_API_HOST}/api/v2/storefront/cart/set_quantity?include=line_items,line_items.variant.images,variants.product.images,line_items.data_extras,variants.product.data_extra_types`)
            .set('X-Spree-Order-Token', params.token)
            .set('Content-Type', 'application/vnd.api+json')
            .query(sanitizedQueryParams)
            .send({
                line_item_id: params.lineItemId,
                quantity: params.quantity,
                zone_id: params.zoneId,
            })
            .then((response) => response);
    },
};

export default LineItemAPI;



/** WEBPACK FOOTER **
 ** ./src/apis/line-item.js
 **/